import { type ReactNode } from 'react'
import { Controller, type FieldValues, type UseControllerProps } from 'react-hook-form'

import NumberField from 'modules/core/components/NumberField'

type NumberFieldProps<TFieldValues extends FieldValues> = Pick<
  UseControllerProps<TFieldValues>,
  'control' | 'name'
> & {
  placeholder?: string
  indicator?: ReactNode
  completed?: boolean
  label?: string
  secondaryLabel?: ReactNode | ReactNode[]
  readonly?: boolean
}

function NumberInputField<TFieldValues extends FieldValues>({
  placeholder,
  indicator,
  readonly,
  label,
  secondaryLabel,
  ...props
}: NumberFieldProps<TFieldValues>): JSX.Element {
  return (
    <Controller
      {...props}
      render={({ field }) => {
        return (
          <NumberField
            {...field}
            label={label}
            completed={props.completed}
            secondaryLabel={secondaryLabel}
            indicator={indicator}
            placeholder={placeholder}
            readonly={readonly}
          />
        )
      }}
    />
  )
}

export { NumberInputField }
